import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Mail } from 'lucide-react';

const BulkPurchasePage = () => {
  const [settings, setSettings] = useState({ contact_email: '', contact_phone: '' });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cms/settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-12 pt-20 max-w-2xl text-center">
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-secondary mb-3">Wholesale</p>
        <h1 className="text-4xl font-black font-heading mb-4" data-testid="bulk-purchase-heading">Bulk Purchase</h1>
        <p className="text-muted-foreground mb-10 text-base">Contact us for bulk orders, corporate gifting, and wholesale pricing.</p>

        <div className="space-y-4 max-w-sm mx-auto">
          {settings.contact_phone && (
            <a href={`tel:${settings.contact_phone}`} className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-[#E0E0E0] hover:border-primary transition-colors" data-testid="bulk-phone">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center"><Phone className="h-5 w-5 text-primary" /></div>
              <div className="text-left">
                <p className="text-xs text-muted-foreground">Phone</p>
                <p className="font-semibold">{settings.contact_phone}</p>
              </div>
            </a>
          )}
          {settings.contact_email && (
            <a href={`mailto:${settings.contact_email}?subject=Bulk Purchase Inquiry`} className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-[#E0E0E0] hover:border-primary transition-colors" data-testid="bulk-email">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center"><Mail className="h-5 w-5 text-primary" /></div>
              <div className="text-left">
                <p className="text-xs text-muted-foreground">Email</p>
                <p className="font-semibold">{settings.contact_email}</p>
              </div>
            </a>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BulkPurchasePage;
